import React from "react";
import _ from "lodash";
import { FormattedMessage, injectIntl } from "react-intl";

import DetailView from "components/DetailView";
import { ROLE_IDS } from "constants/.";

const CompanyDetailsCard = ({ currentItem, intl: { formatMessage } }) => (
  <DetailView
    renderExpanded={() => (
      <div className="card-row">
        <div className="card-column">
          <div className="card-item column">
            {currentItem.OtherRelation && (
              <div className="card-item-value">
                <h3>
                  {_.has(currentItem, "OtherRelation.Number")
                    ? `${formatMessage({ id: "RELATION_NR" })} ${
                        currentItem.OtherRelation.Number
                      }`
                    : "-"}
                </h3>
                <h3>
                  {_.has(currentItem, "OtherRelation.OfficeNumber")
                    ? `T. ${currentItem.OtherRelation.OfficeNumber}`
                    : "-"}
                </h3>
                <h3>
                  {_.has(currentItem, "OtherRelation.MailAddress")
                    ? `E. ${currentItem.OtherRelation.MailAddress}`
                    : "-"}
                </h3>
              </div>
            )}
          </div>
        </div>
        <div className="card-column">
          <div className="card-item column">
            {currentItem.Supplier && (
              <div className="card-item-value">
                <h3>
                  {_.has(currentItem, "Supplier.Number")
                    ? `${formatMessage({ id: "RELATION_NR" })} ${
                        currentItem.Supplier.Number
                      }`
                    : "-"}
                </h3>
                <h3>
                  {_.has(currentItem, "Supplier.OfficeNumber")
                    ? `T. ${currentItem.Supplier.OfficeNumber}`
                    : "-"}
                </h3>
                <h3>
                  {_.has(currentItem, "Supplier.MailAddress")
                    ? `E. ${currentItem.Supplier.MailAddress}`
                    : "-"}
                </h3>
              </div>
            )}
          </div>
        </div>
        <div className="card-column">
          <div className="cart-item column">
            {ROLE_IDS[currentItem.RoleId] === "Supplier" && (
              <div className="card-item-value">
                <h3>
                  {_.has(currentItem, "Seller.Number")
                    ? `${formatMessage({ id: "RELATION_NR" })} ${
                        currentItem.Seller.Number
                      }`
                    : "-"}
                </h3>
              </div>
            )}
          </div>
        </div>
      </div>
    )}
  >
    <div className="card-row">
      <div className="card-column">
        <div className="card-item column">
          <span className="card-item-label">
            <FormattedMessage id="COUNTERPARTY" />
          </span>
          <h3 className="card-item-value">
            {_.get(currentItem, "OtherRelation.Name", "-")}
          </h3>
        </div>
      </div>
      <div className="card-column">
        <div className="card-item column">
          <span className="card-item-label">
            <FormattedMessage id="PREFERRED_GROWER" />
          </span>
          <h3 className="card-item-value">
            {_.get(currentItem, "Supplier.Name", "-")}
          </h3>
        </div>
      </div>
      <div className="card-column">
        <div className="card-item column">
          <span className="card-item-label">
            <FormattedMessage id="GROWER" />
          </span>
          <h3 className="card-item-value">
            {ROLE_IDS[currentItem.RoleId] === "Supplier"
              ? _.get(currentItem, "Seller.Name", "-")
              : "-"}
          </h3>
        </div>
      </div>
    </div>
  </DetailView>
);

export default injectIntl(CompanyDetailsCard);
